<template>
  <section class="home-intro" aria-labelledby="home-intro-heading">
    <div class="max-w-screen-xl mx-auto px-6">
      <div class="home-intro-inner">
        <span class="home-intro-eyebrow">Over Plug2Charge</span>
        <h2 id="home-intro-heading" class="home-intro-title">
          Jouw eigen stroom opslaan: simpel, betaalbaar, nu
        </h2>

        <div class="home-intro-body">
          <p>
            Bij Plug2Charge vind je
            <router-link to="/categorie/thuisbatterijen">thuisbatterijen van 1,92 tot 20+ kWh</router-link>
            waarmee je overdag opgewekte zonnestroom 's avonds zelf gebruikt. Van compacte
            plug&nbsp;&amp;&nbsp;play accu's die je gewoon op het stopcontact aansluit, tot complete
            batterijsystemen voor grotere verbruikers, met technisch advies dat klopt.
          </p>
          <p>
            We werken uitsluitend met A-merken: Hoymiles, Marstek, Conow en GoodWe. Producten die zijn
            getest op veiligheid, rendement en levensduur. Onze energiespecialisten helpen je de juiste
            capaciteit en opstelling kiezen voor jouw situatie, gratis en vrijblijvend.
          </p>
          <p>
            Alles uit eigen voorraad: voor 15:00 besteld, morgen in huis. Gratis verzending vanaf €50,
            2 jaar garantie en 30 dagen retour. Weet je niet waar je moet beginnen?
            Doe de <router-link to="/keuzehulp">keuzehulp</router-link> of
            <router-link to="/klantenservice">neem contact op</router-link>. We denken vrijblijvend met je mee.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// Statische SEO-/introsectie: geeft context en keyword-dekking (zonnepanelen,
// laadpalen, thuisbatterijen, laadpaal kopen, thuisaccu) plus beschrijvende
// interne links naar de drie pijlers. Volledig server-rendered.
</script>

<style scoped>
.home-intro {
  background: #fff;
  padding: 4rem 0;
  border-top: 1px solid #efefef;
}

.home-intro-inner {
  max-width: 760px;
}

.home-intro-eyebrow {
  display: inline-block;
  background: #FFF3B0;
  color: #7a5f00;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 0.25rem 0.75rem;
  border-radius: 50px;
  margin-bottom: 0.875rem;
}

.home-intro-title {
  font-size: clamp(1.5rem, 3.2vw, 2.125rem);
  font-weight: 900;
  color: #111;
  line-height: 1.15;
  letter-spacing: -0.02em;
  margin: 0 0 1.25rem;
  text-wrap: balance;
}

.home-intro-body p {
  font-size: 1rem;
  line-height: 1.75;
  color: #444;
  margin: 0 0 1rem;
}
.home-intro-body p:last-child { margin-bottom: 0; }

.home-intro-body :deep(a) {
  color: #111;
  font-weight: 600;
  text-decoration: none;
  box-shadow: inset 0 -2px 0 0 #FFD500;
  transition: box-shadow 0.15s, background 0.15s;
}
.home-intro-body :deep(a:hover) {
  background: #fffbeb;
  box-shadow: inset 0 -3px 0 0 #FFD500;
}
</style>
